module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAAAXNSR0IArs4c6QAAAMxJREFUSA3FlmEOgzAIRs1usd3CC6y7idf0UDPZDbqvOpoGkUFlmQkpRXiv6Q/jkHOeELch+AEzIeYVi+SOeCIeUR6w0oc5ViYKYaJGkKqAkgiRKogQmQRnRC5Bj6hL4BGdEjDRUmBUozVEoMFCBZLoJwImekFSYnd91CetF6n4l1p7RW0edhgJKtW6hRpMe2cWWiCWnkOhZ9jTW4U9Q64ZV3M91paYZk1NDMy3KkN9yUlf9iILxSui/Ei4PhWaaydCYYoUkBzMETGX9Q3JGctlXl3sGQAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/video-player/close.png
 ** module id = 346
 ** module chunks = 0
 **/